/* eslint-disable react/no-unknown-property */
import React from 'react';
import * as styles from './TeamLeaderboardPosition.style';
import AgentLeaderboardItemSkeleton from '../agent-leaderboard-item/AgentLeaderboardItem.skeleton';

const TeamLeaderboardPositionSkeleton: React.FC = () => (
  <div css={styles.basic}>
    {Array.from({ length: 5 }).map(() => (
      <AgentLeaderboardItemSkeleton size="S" />
    ))}
  </div>
);

export default TeamLeaderboardPositionSkeleton;
